module.exports = __webpack_public_path__ + "static/media/Guitar-7.2fadfb6e.jpg";